import useSWRImmutable from "swr/immutable";
import * as z from "zod/mini";

import { fetchTicketRedeemGroups } from "./fetchTicketRedeemGroups";

const LOCALSTORAGE_KEY = "selectedRedeemGroupIds";

export const getSelectedRedeemGroupIds = (): string[] => {
  try {
    const stored = localStorage.getItem(LOCALSTORAGE_KEY);
    if (!stored) return [];
    const result = z.array(z.string()).safeParse(JSON.parse(stored));
    if (!result.success) return [];
    return result.data;
  } catch {
    return [];
  }
};

export const setSelectedRedeemGroupIds = (ids: string[]) => {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(ids));
};
const fetchSelectedRedeemTicketIds = async (
  selectedGroupIds: string[]
): Promise<{
  ticketIds: string[];
  eventIds: string[];
}> => {
  if (selectedGroupIds.length === 0) return { ticketIds: [], eventIds: [] };

  const ticketRedeemGroups = await fetchTicketRedeemGroups();

  const groups = ticketRedeemGroups.filter((group) =>
    selectedGroupIds.includes(group._id)
  );

  const ticketIds = groups.flatMap((group) => group.ticketIds);
  const eventIds = groups.flatMap((group) => group.eventIds);
  return {
    ticketIds: Array.from(new Set(ticketIds)),
    eventIds: Array.from(new Set(eventIds)),
  };
};

/**
 * 選択されたもぎりグループに属するticketIdとeventIdの一覧を返す
 */
export const useSelectedRedeemTicketIdsAndEventIds = () => {
  const selectedGroupIds = getSelectedRedeemGroupIds();
  return useSWRImmutable<
    {
      ticketIds: string[];
      eventIds: string[];
    },
    Error
  >(["selectedRedeemTicketIds", selectedGroupIds], async (_args) =>
    fetchSelectedRedeemTicketIds(selectedGroupIds)
  );
};
